import React from 'react';
import { Maybe, Price } from 'src/types';

type PriceListContextValue = {
  ourChoice?: Maybe<Price>;
};

export const PriceListContext = React.createContext<PriceListContextValue>({});
